fetch('http://pro.ip-api.com/json/?key=8CpLowEm63dKvrD')
  .then((res) => res.json())
  .then((res) => {
    localStorage.setItem('userData', JSON.stringify(res));
    window.dispatchEvent(new Event('userDataUpdated'));
    if (res.countryCode == 'CA' && window.location.host !== 'factorypure.ca') {
      window.location = `https://factorypure.ca${window.location.pathname}${window.location.search}${window.location.hash}`;
    }
  });

window.CAD_CONVERSION_RATE = JSON.parse(localStorage.getItem('cad_conversion_rate') || '{}');

if (
  window.location.host === 'factorypure.ca' &&
  (!window.CAD_CONVERSION_RATE.conversion_rate || window.CAD_CONVERSION_RATE.exp < Date.now())
) {
  fetch('https://www.fpapplications.com/exchangeRates?currency_code=CAD')
    .then((res) => res.json())
    .then((res) => {
      window.CAD_CONVERSION_RATE.conversion_rate = res.conversion_rate;
      window.CAD_CONVERSION_RATE.exp = Date.now() + 1000 * 60 * 60;
      localStorage.setItem('cad_conversion_rate', JSON.stringify(window.CAD_CONVERSION_RATE));
      window.dispatchEvent(new Event('conversionRateUpdate'));
    });
}
